var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tws-nav-link',{staticClass:"news-item",attrs:{"href":_vm.getNewsViewLink(_vm.news.sys.id)}},[_c('span',{staticClass:"news-item__title"},[_vm._v(" "+_vm._s(_vm.news.title)+" ")]),_c('span',{staticClass:"news-item__date"},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.news.publishDate))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }